import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { PopoverRef } from '@mandae/ng-popover';
import * as moment from 'moment';
import { AuthService } from '../../services/ajs-auth.service';
import { ClienteResource } from '../../services/ajs-cliente-resource.service';
import { PerfilService } from '../../services/ajs-perfil.service';
import { UiRouterState } from '../../services/ajs-router-state.service';
import { StateParamsService } from '../../services/ajs-state-params.service';
import { TourStep } from '../../tour/tour-step';
import { TourService } from '../../tour/tour.service';
import { CollectionSettingsFormComponent } from './collection-settings-form/collection-settings-form.component';

@Component({
  selector: 'mandae-profile-pickup',
  templateUrl: './collection-settings.component.html',
  styleUrls: ['./collection-settings.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CollectionSettingsComponent implements OnInit {
  private weekdays = {
    1: 'Seg',
    2: 'Ter',
    3: 'Qua',
    4: 'Qui',
    5: 'Sex',
  };

  address: any;
  averageSpend: string;
  workPause: any;
  pickupMode: string;
  pickupTime: string;
  workTime: any;
  loading: boolean;

  constructor (
    private auth: AuthService,
    private customer: ClienteResource,
    private profile: PerfilService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private state: StateParamsService,
    private router: UiRouterState,
    private tour: TourService,
  ) { }

  async ngOnInit() {
    await this.loadData();

    if (this.state.showSetupDialog) {
      this.dialog.open(CollectionSettingsFormComponent, {
          closeOnNavigation: true,
          width: '600px',
          maxWidth: '95vw',
          data: {},
        })
        .afterClosed()
        .subscribe(() => this.loadData());
    }

    if (this.state.tour) {
      this.startTour();
    }
  }

  private async loadData() {
    try {
      const user = this.auth.getCurrentUser();

      const addresses = await this.customer.getAddresses({clientId: user.id}).$promise;
      this.address = addresses.find(endereco => endereco.ativo);

      const customerData = await this.profile.getClienteData(user.id);
      this.averageSpend = customerData.gastoMensalComFrete;
      this.pickupMode = customerData.formaColeta;
      this.pickupTime = customerData.horaLimiteColeta;

      if (customerData.inicioExpedientePausa && customerData.fimExpedientePausa) {
        this.workPause = {
          begin: this.formatLocalTime(customerData.inicioExpedientePausa),
          end: this.formatLocalTime(customerData.fimExpedientePausa)
        };
      }

      this.workTime = this.getWorkTime(customerData.horariosInicioExpedicao, customerData.horariosFimExpedicao);
    } catch (e) {
      this.snackBar.open('Houve uma falha ao carregar as informações de pedido.', 'Ok');
    }

  }

  goToAddressPage() {
    this.router.go('enderecos');
  }

  private formatLocalTime(time) {
    return moment(time, ['h,m,ZZ']);
  }

  private getWorkTime(beginTimes, endTimes) {
    const workTime = Object.keys(beginTimes)
      .map((_, index) => {
        const day = index + 1;
        return {
          day: day,
          begin: beginTimes[day], end: endTimes[day]};
      })
      .reduce((acc, time) => {
        const equalTime = acc.find(entry => entry.begin === time.begin && entry.end === time.end);
        if (equalTime) {
          equalTime.count += 1;
          equalTime.days.push(time.day);
        } else {
          acc.push({begin: time.begin, end: time.end, count: 1, days: [time.day]});
        }
        return acc;
      }, [])
      .sort((a, b) => b.count - a.count);

    return { main: workTime[0], exceptionTimes: workTime.slice(1) };
  }

  public getWorkTimeDays(days) {
    const begin = this.weekdays[Math.min(...days)];
    const end = this.weekdays[Math.max(...days)];

    return begin !== end ? begin + ' - ' + end : begin;
  }

  private startTour() {
    const stepsConfig: TourStep[] = [
      {
        title: 'Sua configuração',
        text: 'Veja quais são os dados configurados em sua conta para que a Mandaê possa realizar as coletas de suas encomendas.',
        attachTarget: () => document.querySelector<HTMLElement>('app-toolbar .mat-tab-link:nth-child(3)'),
        next: {
          text: 'Ir para Encomendas',
          action: (ev: MouseEvent, ref: PopoverRef) => {
            ref.close('to_next_section');
            this.router.go('encomendas', { tour: true });
          },
        },
        previous: {
          text: 'Voltar',
          action: (ev, ref) => {
            ref.close('to_prev_section');
            this.router.go('lista-pedidos', { tour: true }, { inherit: false });
          },
        },
      },
    ];

    const steps = this.tour.makeTour(stepsConfig);

    this.tour.start(steps).subscribe();
  }

}
